module.exports = {"621121100":"平襄镇","621121101":"马营镇","621121102":"鸡川镇","621121103":"榜罗镇","621121104":"常家河镇","621121105":"义岗川镇","621121106":"陇阳镇","621121107":"陇山镇","621121108":"陇川镇","621121109":"碧玉镇","621121110":"襄南镇","621121111":"什川镇","621121112":"华家岭镇","621121113":"北城铺镇","621121203":"新景乡","621121207":"李家店乡","621121212":"第三铺乡","621121215":"寺子川乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621121.json
// module id = 3087
// module chunks = 0